import '../../sass/blocks/finish-list.scss';

import cachios from 'cachios';
import Details from '../classes/Details';
import { checkOnScreenEls } from '../common/on-screen';
import FilterSelection from '../classes/FilterSelection';

(() => {
    const $finishLists = document.querySelectorAll('.finish-list');

    if (!$finishLists) return;

    $finishLists.forEach($finishList => {
        const $filterModalDetails = $finishList.querySelectorAll('.finish-list-filter-modal__filter-details');

        const $filterModal = $finishList.querySelector('.finish-list-filter-modal');
        const $filterModalForm = $filterModal?.querySelector('.finish-list-filter-modal__form');
        const $filterModalFormInputs = $filterModal?.querySelectorAll('input');
        const $filterModalClearAll = $filterModal?.querySelector('.finish-list-filter-modal__clear-all');
        const $filterSelections = $filterModal?.querySelectorAll('.filter-selection');

        const $filter = $finishList.querySelector('.finish-list-filter');
        const $filterForm = $finishList.querySelector('.finish-list-filter__form');
        const $filterFormSelects = $filterForm?.querySelectorAll('select');

        const $gridInner = $finishList.querySelector('.finish-list-grid__inner');
        const $loadMoreForm = $finishList.querySelector('.finish-list-grid__load-more-form');

        let loadingMore = false;

        const updateLoadMoreFormFields = ({
            page,
            products,
            textures,
            sheens,
            areasOfUse,
        }) => {
            if (!$loadMoreForm) return;

            const $finishPage = $loadMoreForm?.querySelector('[name="finish_page"]');

            if ($finishPage && page) {
                $finishPage.value = page;
            }

            const $filterFields = $loadMoreForm.querySelectorAll('[name="form_products[]"], [name="form_textures[]"], [name="form_sheens[]"], [name="form_areas_of_use[]"]');

            if ($filterFields) {
                $filterFields.forEach($filterField => {
                    $filterField.remove();
                });
            }

            products?.forEach(product => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_products[]" value="${product}" autocomplete="off">`);
            });

            textures?.forEach(texture => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_textures[]" value="${texture}" autocomplete="off">`);
            });

            sheens?.forEach(sheen => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_sheens[]" value="${sheen}" autocomplete="off">`);
            });

            areasOfUse?.forEach(areaOfUse => {
                $loadMoreForm.insertAdjacentHTML('afterbegin', `<input type="hidden" name="form_areas_of_use[]" value="${areaOfUse}" autocomplete="off">`);
            });
        };

        const filterFinishes = ({
            nonce,
            products,
            textures,
            sheens,
            areasOfUse,
        }) => {
            if (!$gridInner) return;

            $gridInner.classList.add('finish-list-grid__inner--loading');

            cachios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'armourcoat_theme_ajax_get_finishes_list', 
                    nonce,
                    products: products,
                    textures: textures,
                    sheens: sheens,
                    areas_of_use: areasOfUse,
                }
            }).then(response => {
                if (!response?.data?.success) return;

                if (response?.data?.finishes) {
                    $gridInner.innerHTML = response.data.finishes;
                }

                if (!response?.data?.finishes) {
                    $gridInner.innerHTML = '';
                }

                checkOnScreenEls();

                updateLoadMoreFormFields({
                    page: 2,
                    products,
                    textures,
                    sheens,
                    areasOfUse,
                });

                // Show/hide load more button
                if ($loadMoreForm) {
                    if (response?.data?.post_count >= response?.data?.found_posts || !response?.data?.finishes) {
                        $loadMoreForm.classList.remove('finish-list-grid__load-more-form--show');
                    } else {
                        $loadMoreForm.classList.add('finish-list-grid__load-more-form--show');
                    }
                }
            }).finally(() => {
                $gridInner.classList.remove('finish-list-grid__inner--loading');
            });
        };

        const loadMore = () => {
            if (loadingMore || !$gridInner || !$loadMoreForm || !$loadMoreForm.classList.contains('finish-list-grid__load-more-form--show')) return;

            const $nonce = $loadMoreForm.querySelector('[name="armourcoat_theme_load_more_finishes_list_wpnonce"]');
            const $finishPage = $loadMoreForm.querySelector('[name="finish_page"]');
            const $postsPerPage = $loadMoreForm.querySelector('[name="posts_per_page"]');
            const $products = $loadMoreForm.querySelectorAll('[name="form_products[]"]');
            const $textures = $loadMoreForm.querySelectorAll('[name="form_textures[]"]');
            const $sheens = $loadMoreForm.querySelectorAll('[name="form_sheens[]"]');
            const $areasOfUse = $loadMoreForm.querySelectorAll('[name="form_areas_of_use[]"]');

            const productValues = $products ? Array.from($products).map($product => $product.value) : null;
            const textureValues = $textures ? Array.from($textures).map($texture => $texture.value) : null;
            const sheenValues = $sheens ? Array.from($sheens).map($sheen => $sheen.value) : null;
            const areaOfUseValues = $areasOfUse ? Array.from($areasOfUse).map($areaOfUse => $areaOfUse.value) : null;

            loadingMore = true;

            $gridInner.classList.add('finish-list-grid__inner--loading');

            cachios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'armourcoat_theme_ajax_load_more_finishes', 
                    nonce: $nonce?.value,
                    page: $finishPage?.value,
                    posts_per_page: $postsPerPage?.value,
                    products: productValues,
                    textures: textureValues,
                    sheens: sheenValues,
                    areasOfUse: areaOfUseValues,
                }
            }).then(response => {
                if (!response?.data?.success) return;

                if (response?.data?.finishes) {
                    $gridInner.insertAdjacentHTML('beforeend', response.data.finishes);
                }

                if (response?.data?.page && $finishPage) {
                    $finishPage.value = parseInt(response.data.page) + 1;
                }

                // Show/hide load more button
                if (response?.data?.post_count >= response?.data?.found_posts || !response?.data?.finishes) {
                    $loadMoreForm.classList.remove('finish-list-grid__load-more-form--show');
                } else {
                    $loadMoreForm.classList.add('finish-list-grid__load-more-form--show');
                }

                infiniteLoad();
                checkOnScreenEls();
            }).finally(() => {
                $gridInner.classList.remove('finish-list-grid__inner--loading');

                loadingMore = false;
            });
        };

        const infiniteLoad = () => {
            if (!$gridInner || $gridInner.getBoundingClientRect().top + $gridInner.offsetHeight - window.innerHeight > 0) return;

            loadMore();
        };

        const initFilterSelections = () => {
            if (!$filterSelections) return;

            $filterSelections.forEach($filterSelection => {
                new FilterSelection($filterSelection);
            });
        };

        const initFilterExpandable = () => {
            if (!$filterModalDetails) return;

            $filterModalDetails.forEach($filterModalDetails => {
                new Details($filterModalDetails);
            });
        };

        const submitFilterForm = ($form) => {
            if (!$form) return;

            const $nonce = $form.querySelector('[name=armourcoat_theme_get_finish_list_filter_wpnonce]');
            const $products = $form.querySelectorAll('[name="form_products[]"]');
            const $textures = $form.querySelectorAll('[name="form_textures[]"]');
            const $sheens = $form.querySelectorAll('[name="form_sheens[]"]');
            const $areaOfUse = $form.querySelectorAll('[name="form_areas_of_use[]"]');

            let productValues = [];
            let textureValues = [];
            let sheenValues = [];
            let areaOfUseValues = [];

            if ($products) {
                $products.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            productValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        productValues.push($input.value);
                    }
                });
            }

            if ($textures) {
                $textures.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            textureValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        textureValues.push($input.value);
                    }
                });
            }

            if ($sheens) {
                $sheens.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            sheenValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        sheenValues.push($input.value);
                    }
                });
            }

            if ($areaOfUse) {
                $areaOfUse.forEach($input => {
                    if ($input?.options) {
                        Array.from($input?.options)?.filter($option => $option?.selected).forEach($option => {
                            areaOfUseValues.push($option.value);
                        });
                    }
                    
                    if ($input?.checked) {
                        areaOfUseValues.push($input.value);
                    }
                });
            }

            filterFinishes({
                nonce: $nonce?.value,
                products: productValues,
                textures: textureValues,
                sheens: sheenValues,
                areasOfUse: areaOfUseValues,
            });
        };

        const initfilterModalForm = () => {
            if (!$filterModalForm) return;

            $filterModalForm.addEventListener('submit', e => {
                e.preventDefault();

                submitFilterForm($filterModalForm);
            });

            if ($filterModalFormInputs) {
                $filterModalFormInputs.forEach($input => {
                    $input.addEventListener('change', () => {
                        submitFilterForm($filterModalForm);
                    });
                });
            }

            if ($filterModalClearAll && $filterModalFormInputs) {
                $filterModalClearAll.addEventListener('click', () => {
                    $filterModalFormInputs.forEach($input => {
                        $input.checked = false;
                        $input.dispatchEvent(new Event('change'));
                    });

                    submitFilterForm($filterModalForm);
                });
            }
        };

        const initFilterForm = () => {
            if (!$filter || !$filterForm) return;

            new FilterSelection($filter);
            
            $filterForm.addEventListener('submit', e => {
                e.preventDefault();

                submitFilterForm($filterForm);
            });

            $filterFormSelects.forEach($select => {
                $select.addEventListener('change', () => {
                    submitFilterForm($filterForm);
                });
            });
        };

        window.addEventListener('scroll', () => {
            infiniteLoad();
        });

        initFilterSelections();
        initFilterExpandable();
        initfilterModalForm();
        initFilterForm();
    });
})();
